import { render, staticRenderFns } from "./SchoolsComponent.vue?vue&type=template&id=c8559cc6&scoped=true"
import script from "./SchoolsComponent.vue?vue&type=script&lang=js"
export * from "./SchoolsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8559cc6",
  null
  
)

export default component.exports